/**
 * Step 7 — recommendation score + supplements (from recommendation_animation.html).
 * All graph class/ID names use the cs-rg7- prefix (unique vs step 5 cs-health- / cs-hs-).
 * window.csRecGraphStep7.start(stepRoot, { onComplete })
 * window.csRecGraphStep7.stop()
 */
(function () {
  var START = 87;
  var END = 93;
  var ARC_R = 52;
  var ARC_C = 2 * Math.PI * ARC_R;
  var ARC_CX = 64;
  var ARC_CY = 64;

  var GREEN_RGB = [52, 199, 89];
  var BLUE_RGB = [0, 180, 255];

  var FLOAT_PARAMS = [
    { dur: '5.8s', delay: '0s' },
    { dur: '6.3s', delay: '-1.4s' },
    { dur: '5.5s', delay: '-2.7s' },
    { dur: '6.1s', delay: '-0.8s' }
  ];

  var activeRoot = null;
  var seqGen = 0;
  var timers = [];
  var resizeObserver = null;
  var flowRaf = null;
  var particles = [];
  var flowActive = false;
  var spawnUntil = 0;
  var paths = [];
  var canvas = null;
  var ctx = null;
  var _currentPct = START;
  var _hasBurst = false;

  function $(root, sel) {
    return root ? root.querySelector(sel) : null;
  }

  function clearTimers() {
    timers.forEach(function (id) {
      clearTimeout(id);
    });
    timers = [];
  }

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function lerpRGB(a, b, t) {
    t = Math.max(0, Math.min(1, t));
    return [
      Math.round(a[0] + (b[0] - a[0]) * t),
      Math.round(a[1] + (b[1] - a[1]) * t),
      Math.round(a[2] + (b[2] - a[2]) * t)
    ];
  }

  function colorT(pct) {
    if (pct <= 89) return 0;
    if (pct >= END) return 1;
    return (pct - 89) / (END - 89);
  }

  function rgbStr(pct) {
    var rgb = lerpRGB(GREEN_RGB, BLUE_RGB, colorT(pct));
    return 'rgb(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ')';
  }

  function rgbaStr(pct, alpha) {
    var rgb = lerpRGB(GREEN_RGB, BLUE_RGB, colorT(pct));
    return 'rgba(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ',' + alpha + ')';
  }

  function stopFlowSoon() {
    spawnUntil = Math.min(spawnUntil, performance.now() + 480);
  }

  function pointOnQuad(t, ax, ay, cx, cy, bx, by) {
    var u = 1 - t;
    return {
      x: u * u * ax + 2 * u * t * cx + t * t * bx,
      y: u * u * ay + 2 * u * t * cy + t * t * by
    };
  }

  function rebuildPaths(root, composition, scoreWrap, cards) {
    paths = [];
    var comp = composition.getBoundingClientRect();
    var tw = comp.width;
    var th = comp.height;
    if (tw < 4 || th < 4) return;

    var scorePx = scoreWrap.getBoundingClientRect();
    var tcx = scorePx.left + scorePx.width / 2 - comp.left;
    var tcy = scorePx.top + scorePx.height / 2 - comp.top;

    for (var idx = 0; idx < cards.length; idx++) {
      var card = cards[idx];
      var r = card.getBoundingClientRect();
      var ax = r.left + r.width / 2 - comp.left;
      var ay = r.top - comp.top;
      var bx = tcx;
      var by = tcy + ARC_R * 0.55;
      var mx = (ax + bx) / 2 + (idx % 2 === 0 ? -10 : 10);
      var my = Math.min(ay - 24, tcy + ARC_R * 1.1);
      paths.push({ ax: ax, ay: ay, bx: bx, by: by, cx: mx, cy: my });
    }
  }

  function spawnParticle(pathIdx) {
    if (!paths[pathIdx]) return;
    var highlight = Math.random() < 0.15;
    particles.push({
      pathIdx: pathIdx,
      t: 0,
      speed: 0.009 + Math.random() * 0.01,
      r: (highlight ? 1.1 : 0.55) + Math.random() * 0.55,
      alpha: (highlight ? 0.055 : 0.032) + Math.random() * 0.04,
      highlight: highlight,
      pct: _currentPct,
      trail: []
    });
  }

  function tick(composition, scoreWrap) {
    if (!ctx || !canvas || !composition) return;

    var rect = composition.getBoundingClientRect();
    ctx.clearRect(0, 0, rect.width, rect.height);

    var scorePx = scoreWrap.getBoundingClientRect();
    var tcx = scorePx.left + scorePx.width / 2 - rect.left;
    var tcy = scorePx.top + scorePx.height / 2 - rect.top;
    var ringRpx = (ARC_R / 128) * scorePx.width;

    for (var i = particles.length - 1; i >= 0; i--) {
      var p = particles[i];
      var pth = paths[p.pathIdx];
      if (!pth) {
        particles.splice(i, 1);
        continue;
      }

      p.t += p.speed;
      if (p.t >= 1) {
        particles.splice(i, 1);
        continue;
      }

      var pt = pointOnQuad(p.t, pth.ax, pth.ay, pth.cx, pth.cy, pth.bx, pth.by);
      var dx = pt.x - tcx;
      var dy = pt.y - tcy;
      var dist = Math.sqrt(dx * dx + dy * dy);
      var fade = dist < ringRpx + 30 ? Math.max(0.18, dist / (ringRpx + 30)) : 1;
      var dimT = 1 - p.t * 0.3;

      p.trail.push({ x: pt.x, y: pt.y });
      if (p.trail.length > 9) p.trail.shift();

      for (var j = 1; j < p.trail.length; j++) {
        var t0 = p.trail[j - 1];
        var t1 = p.trail[j];
        var ta = j / p.trail.length;
        var trailA = p.alpha * 0.38 * ta * fade * dimT;
        ctx.beginPath();
        ctx.moveTo(t0.x, t0.y);
        ctx.lineTo(t1.x, t1.y);
        ctx.strokeStyle = rgbaStr(p.pct, trailA);
        ctx.lineWidth = p.r * 0.75;
        ctx.lineCap = 'round';
        ctx.stroke();
      }

      var headA = p.alpha * fade * dimT;
      ctx.beginPath();
      ctx.arc(pt.x, pt.y, p.r * 3.2, 0, Math.PI * 2);
      ctx.fillStyle = rgbaStr(p.pct, headA * 0.18);
      ctx.fill();

      ctx.beginPath();
      ctx.arc(pt.x, pt.y, p.r, 0, Math.PI * 2);
      ctx.fillStyle = rgbaStr(p.pct, Math.min(0.55, headA * 1.6));
      ctx.fill();
    }

    if (performance.now() < spawnUntil && paths.length) {
      if (Math.random() < 0.44) {
        spawnParticle(Math.floor(Math.random() * paths.length));
      }
    }

    if (particles.length || performance.now() < spawnUntil) {
      flowRaf = requestAnimationFrame(function () {
        tick(composition, scoreWrap);
      });
    } else {
      flowRaf = null;
      flowActive = false;
    }
  }

  function resizeCanvas(root, composition, scoreWrap, cards) {
    if (!canvas || !ctx || !composition) return;
    var rect = composition.getBoundingClientRect();
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.max(1, Math.floor(rect.width * dpr));
    canvas.height = Math.max(1, Math.floor(rect.height * dpr));
    canvas.style.width = rect.width + 'px';
    canvas.style.height = rect.height + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    rebuildPaths(root, composition, scoreWrap, cards);
  }

  function startFlow(root, composition, scoreWrap, cards, durationMs) {
    resizeCanvas(root, composition, scoreWrap, cards);
    spawnUntil = performance.now() + durationMs;
    flowActive = true;
    particles = [];
    if (!flowRaf) flowRaf = requestAnimationFrame(function () { tick(composition, scoreWrap); });
  }

  function bind(root) {
    return {
      composition: $(root, '#cs-rg7-composition'),
      ambientBlue: $(root, '#cs-rg7-ambientBlue'),
      canvas: $(root, '#cs-rg7-particleCanvas'),
      scoreNum: $(root, '#cs-rg7-scoreNum'),
      scoreWrap: $(root, '#cs-rg7-scoreWrap'),
      scoreHalo: $(root, '#cs-rg7-scoreHalo'),
      ringBurst: $(root, '#cs-rg7-ringBurst'),
      scoreEyebrow: $(root, '#cs-rg7-scoreEyebrow'),
      scoreDelta: $(root, '#cs-rg7-scoreDelta'),
      progArc: $(root, '#cs-rg7-progArc'),
      glowArc: $(root, '#cs-rg7-glowArc'),
      ambientArc: $(root, '#cs-rg7-ambientArc'),
      arcDot: $(root, '#cs-rg7-arcDot'),
      cards: root.querySelectorAll('.cs-rg7-supp-card')
    };
  }

  function resetDom(els) {
    if (!els.composition) return;
    els.composition.classList.remove('cs-rg7-composition--running');
    if (els.ambientBlue) els.ambientBlue.style.opacity = '';
    if (els.scoreEyebrow) {
      els.scoreEyebrow.classList.remove('cs-rg7-score-eyebrow--visible');
    }
    if (els.scoreDelta) els.scoreDelta.classList.remove('cs-rg7-score-delta--visible');
    if (els.scoreWrap) {
      els.scoreWrap.classList.remove(
        'cs-rg7-score-wrap--high',
        'cs-rg7-score-wrap--pulse-once',
        'cs-rg7-score-wrap--pulse-final'
      );
    }
    if (els.ringBurst) els.ringBurst.classList.remove('cs-rg7-ring-burst--firing');
    if (els.cards) {
      els.cards.forEach(function (card) {
        card.classList.remove('cs-rg7-supp-card--on', 'cs-rg7-supp-card--complete');
      });
    }
    _hasBurst = false;
    _currentPct = START;
    particles = [];
    paths = [];
    if (ctx && els.canvas && els.composition) {
      var r = els.composition.getBoundingClientRect();
      ctx.clearRect(0, 0, r.width, r.height);
    }
  }

  function setArcPercent(els, pct) {
    _currentPct = pct;
    var off = ARC_C * (1 - pct / 100);
    var stroke = rgbStr(pct);
    var t = colorT(pct);

    [els.progArc, els.glowArc, els.ambientArc].forEach(function (el) {
      if (!el) return;
      el.setAttribute('stroke-dasharray', String(ARC_C));
      el.setAttribute('stroke-dashoffset', String(off));
      el.setAttribute('stroke', stroke);
    });

    if (els.arcDot) {
      els.arcDot.setAttribute('fill', stroke);
      if (els.scoreWrap) els.scoreWrap.classList.toggle('cs-rg7-score-wrap--high', pct > 90);
      var a = -Math.PI / 2 + (pct / 100) * 2 * Math.PI;
      els.arcDot.setAttribute('cx', String((ARC_CX + ARC_R * Math.cos(a)).toFixed(4)));
      els.arcDot.setAttribute('cy', String((ARC_CY + ARC_R * Math.sin(a)).toFixed(4)));
      els.arcDot.setAttribute('opacity', pct >= 3 ? '1' : String(Math.max(0, pct / 3)));
    }

    if (els.scoreHalo) {
      els.scoreHalo.style.background =
        'radial-gradient(circle at 50% 50%, ' + rgbaStr(pct, 0.09) + ' 25%, transparent 72%)';
      els.scoreHalo.style.opacity = '1';
    }

    if (els.ambientBlue) els.ambientBlue.style.opacity = String(t);

    if (!_hasBurst && pct > 90 && els.ringBurst) {
      _hasBurst = true;
      els.ringBurst.classList.remove('cs-rg7-ring-burst--firing');
      void els.ringBurst.offsetWidth;
      els.ringBurst.classList.add('cs-rg7-ring-burst--firing');
    }
  }

  function initArcStroke(els) {
    [els.progArc, els.glowArc, els.ambientArc].forEach(function (el) {
      if (!el) return;
      el.setAttribute('stroke-dasharray', String(ARC_C));
      el.setAttribute('stroke-dashoffset', String(ARC_C));
      el.setAttribute('stroke', rgbStr(START));
    });
    if (els.arcDot) {
      els.arcDot.setAttribute('opacity', '0');
    }
  }

  function animateScoreArc(els, from, to, durationMs, done) {
    var t0 = performance.now();
    function frame(now) {
      var u = Math.min(1, (now - t0) / durationMs);
      var e = easeOutCubic(u);
      var v = from + (to - from) * e;
      if (els.scoreNum) els.scoreNum.textContent = String(Math.round(v));
      setArcPercent(els, v);
      if (u < 1) {
        requestAnimationFrame(frame);
        return;
      }
      if (els.scoreNum) els.scoreNum.textContent = String(to);
      setArcPercent(els, to);
      if (done) done();
    }
    requestAnimationFrame(frame);
  }

  function hydrateRecPillImages(stepRoot) {
    var pills = typeof window !== 'undefined' && window.pills && typeof window.pills === 'object' ? window.pills : null;
    if (!pills) return;
    var imgs = stepRoot.querySelectorAll('.cs-rg7-pill-img[data-pill-key]');
    imgs.forEach(function (img) {
      var k = img.getAttribute('data-pill-key');
      if (k && pills[k]) {
        img.src = pills[k];
        img.alt = '';
      }
    });
  }

  function scheduleRecSequence(stepRoot, els, gen, onComplete, reduced) {
    var attempts = 0;
    function tickWait() {
      if (seqGen !== gen) return;
      var pills = typeof window !== 'undefined' && window.pills && typeof window.pills === 'object' ? window.pills : null;
      if (pills) {
        hydrateRecPillImages(stepRoot);
        requestAnimationFrame(function () {
          if (seqGen !== gen) return;
          runSequence(stepRoot, els, gen, onComplete, reduced);
        });
        return;
      }
      if (++attempts >= 200) {
        requestAnimationFrame(function () {
          if (seqGen !== gen) return;
          runSequence(stepRoot, els, gen, onComplete, reduced);
        });
        return;
      }
      timers.push(setTimeout(tickWait, 50));
    }
    tickWait();
  }

  function runSequence(root, els, gen, onComplete, reduced) {
    if (gen !== seqGen) return;

    els.composition.classList.add('cs-rg7-composition--running');

    var cards = els.cards ? Array.prototype.slice.call(els.cards) : [];

    cards.forEach(function (card, i) {
      var fp = FLOAT_PARAMS[i] || { dur: '6s', delay: '0s' };
      card.style.setProperty('--float-dur', fp.dur);
      card.style.setProperty('--float-delay', fp.delay);
    });

    initArcStroke(els);
    setArcPercent(els, START);
    if (els.scoreNum) els.scoreNum.textContent = String(START);

    var dIntro = reduced ? 0 : 440;
    var dLabel1 = reduced ? 0 : 580;
    var stagger = reduced ? 0 : 155;
    var tLastCard = dIntro + dLabel1 + 3 * stagger;
    var dScore = reduced ? 650 : 2100;
    var flowDur = reduced ? 900 : 3800;
    var tScoreStart = tLastCard + (reduced ? 80 : 300);
    var tFlow = Math.max(dIntro + dLabel1, tLastCard - (reduced ? 120 : 360));

    timers.push(
      setTimeout(function () {
        if (gen !== seqGen) return;
        if (els.scoreEyebrow) els.scoreEyebrow.classList.add('cs-rg7-score-eyebrow--visible');
      }, reduced ? 0 : 320)
    );

    cards.forEach(function (card, i) {
      timers.push(
        setTimeout(function () {
          if (gen !== seqGen) return;
          card.classList.add('cs-rg7-supp-card--on');
        }, dIntro + dLabel1 + i * stagger)
      );
    });

    timers.push(
      setTimeout(function () {
        if (gen !== seqGen) return;
        startFlow(root, els.composition, els.scoreWrap, cards, flowDur);
      }, tFlow)
    );

    timers.push(
      setTimeout(function () {
        if (gen !== seqGen) return;
        animateScoreArc(els, START, END, dScore, function () {
          if (gen !== seqGen) return;
          if (els.scoreDelta) els.scoreDelta.classList.add('cs-rg7-score-delta--visible');
          cards.forEach(function (card) {
            card.classList.add('cs-rg7-supp-card--complete');
          });
          if (els.scoreWrap) {
            els.scoreWrap.classList.add('cs-rg7-score-wrap--pulse-once');
            timers.push(
              setTimeout(function () {
                if (gen !== seqGen) return;
                els.scoreWrap.classList.remove('cs-rg7-score-wrap--pulse-once');
                els.scoreWrap.classList.add('cs-rg7-score-wrap--pulse-final');
              }, reduced ? 0 : 1050)
            );
          }
          if (onComplete) onComplete();
        });
      }, tScoreStart)
    );

    timers.push(
      setTimeout(function () {
        stopFlowSoon();
      }, tScoreStart + dScore + (reduced ? 350 : 750))
    );
  }

  function teardown(root, els) {
    clearTimers();
    if (flowRaf) {
      cancelAnimationFrame(flowRaf);
      flowRaf = null;
    }
    flowActive = false;
    particles = [];
    spawnUntil = 0;
    if (resizeObserver) {
      try {
        resizeObserver.disconnect();
      } catch (e) {}
      resizeObserver = null;
    }
    canvas = null;
    ctx = null;
    resetDom(els);
    activeRoot = null;
  }

  window.csRecGraphStep7 = {
    start: function (stepRoot, options) {
      options = options || {};
      var onComplete = options.onComplete;
      if (!stepRoot) return;

      window.csRecGraphStep7.stop();

      activeRoot = stepRoot;
      seqGen++;
      var gen = seqGen;

      var els = bind(stepRoot);
      canvas = els.canvas;
      ctx = canvas ? canvas.getContext('2d') : null;

      if (!els.composition || !canvas || !ctx) {
        if (onComplete) onComplete();
        return;
      }

      var reduced = false;
      try {
        reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) {}

      resizeCanvas(stepRoot, els.composition, els.scoreWrap, els.cards);
      if (typeof ResizeObserver !== 'undefined') {
        resizeObserver = new ResizeObserver(function () {
          if (seqGen !== gen || !els.composition) return;
          resizeCanvas(stepRoot, els.composition, els.scoreWrap, els.cards);
        });
        resizeObserver.observe(els.composition);
      }

      requestAnimationFrame(function () {
        if (seqGen !== gen) return;
        scheduleRecSequence(stepRoot, els, gen, onComplete, reduced);
      });
    },

    stop: function () {
      if (!activeRoot) return;
      seqGen++;
      var root = activeRoot;
      var els = bind(root);
      teardown(root, els);
    }
  };
})();
